import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex min-h-[52px] flex-col justify-between gap-3 p-4 sm:flex-row sm:items-center" }
const _hoisted_2 = { class: "min-w-0 flex-1 space-y-0.5" }
const _hoisted_3 = { class: "block text-sm font-medium text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs leading-relaxed text-gray-500"
}
const _hoisted_5 = {
  key: 0,
  class: "flex shrink-0 items-center gap-3"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UiSettingsRow',
  props: {
    title: { default: '' },
    description: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      _renderSlot(_ctx.$slots, "description", {}, () => [
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.$slots.action)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "action")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})